import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function CTWhatIs() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-814">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-815">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-816">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-817">
            WHAT IS COOLTONE?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-818"></div>

          <p className="text-[#333333] text-[17px] leading-[1.8] font-body mb-12" data-id="element-819">
            At Be CLINICAL, we are thrilled to introduce CoolTone, an innovative
            non-surgical body contouring procedure meticulously crafted to
            tighten, fortify and sculpt muscles in key areas like the stomach,
            buttocks and thighs, resulting in a more defined and toned
            appearance.
          </p>

          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-820">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-821">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-822">
              How can you say no to tens of thousands of abdominal crunches done
              for you by a machine in 20 minutes? Do I really need to say
              anything more?
            </p>
          </div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-823">
            <p data-id="element-824">
              This state-of-the-art treatment administers safe bursts of
              electromagnetic energy directly into the muscle fibers,
              circumventing the outer layers of skin and fat. This triggers a
              cascade of involuntary contractions. With a remarkable 25,000
              supramaximal muscle contractions achievable in just one session,
              CoolTone revolutionizes muscle conditioning like never before.
            </p>
            <p data-id="element-825">
              Whether you are looking to tighten your abdomen, lift your
              buttocks or tone your thighs, CoolTone offers a safe, effective
              and non-invasive solution. Patients can relish the advantages of
              improved muscle tone and definition without enduring any downtime
              or discomfort.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}